// fmred-ui urls go here
export const UI_ENDPOINT = {
  GET_UI_FEATURES: "/fmr-edu/casa/uiFeatureMap",
  UI_REFRESH_UIFEATURE: "/fmr-edu/casa/refresh",
  GET_CONTACTUS_AGENCIES_DETAILS_BY_CNTY:
    "/fmr-edu/contactUs/getContactUsBySelCounty",
  GET_FILTERED_COUNTIES: "/fmr-edu/contactUs/getFilteredCounties",
  GET_ALL_CONTACTUS_AGENCIES_DETAILS_BY_CNTY:
    "/fmr-edu/contactUs/getAllContactUsBySelCounty",
  GET_SCHEDULE_COUNTIES: "/fmr-edu/contactUs/getActiveCountiesForSchedule",
};

// tes-app urls go here
export const TES_APP_ENDPOINT = {
  GET_CONTACTUS_AGENCIES_DETAILS_BY_CNTY:
    "/tes-app/public/contactUs/getContactUsBySelCounty",
  GET_FILTERED_COUNTIES: "/tes-app/public/counties/getFilteredCounties",
  GET_ALL_CONTACTUS_AGENCIES_DETAILS_BY_CNTY:
    "/tes-app/public/contactUs/getAllContactUsBySelCounty",
};
